import { useOrgContext } from '@/org/contexts/OrgContext'
import {
  CirclesGraphViews,
  GraphView,
  parseGraphView,
} from '@rolebase/shared/model/graph'
import { useMemo } from 'react'
import { disabledGraphViewsOf } from './graphViewsOfInstance'

// The views switched off for the current organization. The whiteboard follows
// the org's option, set by the super-admin from the console (#210); outside an
// organization it stays off.
export function useDisabledGraphViews(): readonly CirclesGraphViews[] {
  const { org } = useOrgContext()
  const whiteboardEnabled = !!org?.whiteboardEnabled
  return useMemo(
    () => disabledGraphViewsOf(whiteboardEnabled),
    [whiteboardEnabled]
  )
}

// parseGraphView with the organization's switched-off views: a URL or an org
// setting naming one falls back to the caller's default
export function parseOrgGraphView(
  disabled: readonly CirclesGraphViews[],
  view: string | null | undefined,
  folded?: boolean | null,
  members?: boolean | null
): GraphView | undefined {
  return parseGraphView(view, folded, members, disabled)
}
